module.exports = __webpack_public_path__ + "static/media/star-ball_09.810ac7e2.png";